import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query'

import { getArticles, type GetArticlesParams } from './get-articles'

export const campaignQueries = {
  all: () => ['campaigns'],
  articles: () => [...campaignQueries.all(), 'articles'],
  articlesList: (params: GetArticlesParams) =>
    queryOptions({
      queryKey: [...campaignQueries.articles(), params],
      queryFn: () => getArticles(params),
    }),
  articlesInfiniteList: (params: Omit<GetArticlesParams, 'page'>) =>
    infiniteQueryOptions({
      queryKey: [...campaignQueries.articles(), 'infinite', params],
      queryFn: ({ pageParam }) => getArticles({ ...params, page: pageParam }),
      initialPageParam: 1,
      getNextPageParam: lastPage => {
        const { currentPage, lastPage: last } = lastPage.articles

        return currentPage < last ? currentPage + 1 : undefined
      },
    }),
}
